<template>
  <v-card class="mx-auto px-7 pb-7" width="30%" :loading="isPasswordSubmitting">
    <v-card-text>
      <h2 class="text--primary pt-7 pb-5">Change Password</h2>
      <v-form ref="passwordForm">
        <v-text-field
          ref="firstInput"
          type="password"
          v-model="password"
          label="New password"
          :rules="[passwordRules.required, passwordRules.min, passwordRules.alphanumeric, passwordRules.specialChar]"
          required
        ></v-text-field>
        <v-text-field
          type="password"
          v-model="confirmPassword"
          label="Confirm new password"
          :rules="[passwordRules.identicalRule, passwordRules.required, passwordRules.min, passwordRules.alphanumeric, passwordRules.specialChar]"
          required
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="primary" @click="onChangePassword()">Change password</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  mounted: function() {
    this.$refs.firstInput.focus();
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      isPasswordSubmitting: false,
      passwordRules: {
        identicalRule: v =>
          v == this.password || "Confirm password must be same as password",
        min: v => v.length >= 8 || "Min 8 characters",
        required: value => !!value || "This field is required.",
        alphanumeric: v =>
          /^[a-zA-Z0-9!@#$&()\\-`.+,/"]*$/.test(v) || "Alphanumeric only",
        specialChar: v =>
          /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(v) ||
          "At least 1 special character needed"
      }
    };
  },
  methods: {
    onChangePassword: function() {
      if (!this.$refs.passwordForm.validate()) {
        return;
      }

      this.isPasswordSubmitting = true;
      const data = { password: this.password };

      fetch(`${process.env.VUE_APP_ROOT_API}/users/password`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          this.isPasswordSubmitting = false;
          this.$store.commit("updateFirstLogin", false);
          this.$emit("passwordChanged", { message: data.message });
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style scoped>
</style>